exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list[data-v-6e11b9dc] {\n  list-style-type: none;\n}\n.parent[data-v-6e11b9dc] {\n  position: relative;\n}\n.bt[data-v-6e11b9dc] {\n  width: 28px !important;\n}\n.menu[data-v-6e11b9dc] {\n  display: inline-block;\n  width: 30px;\n  height: 75px;\n  border-left: 2px dashed gray;\n  vertical-align: top;\n  padding-left: 3px;\n}\n.scrollme[data-v-6e11b9dc] {\n  /*width: 100%;*/\n  width: calc(100% - 40px);\n  display: inline-block;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\ntable[data-v-6e11b9dc] {\n  padding: 4px;\n}\n", ""]);

// exports
